// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"097f6fbd","167":"37db2584","504":"a8484141","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};